import { type FunctionalComponent, h } from '@stencil/core';
import { ConversationalSearchLabelWithSection } from '../../../conversational-search/conversational-search-partials/label-with-section/label-with-section';
import circularIcon from '../assets/circular-icon.svg'; // It is needed because qds4 icons are not part of first phase and qds 3 is not added to header
import type {labelProviderInterface} from '../../../../LabelProviderInterface';

interface ICircularEconomyBanner {
  isProductTabVariant: boolean;
	labelProvider: labelProviderInterface;
	bannerInteractionHandler: Function;
}

export const CircularEconomyBanner: FunctionalComponent<ICircularEconomyBanner> = (
  props,
) => {

    const text = props.labelProvider(
      'additional.conditions.banner.subtitle',
      'You can now buy sustainable versions of some products using the Conditions filter on the search page.',
    );

    return (
  	<div
        class={{
          'additional-conditions-banner': true,
          'additional-conditions-banner--standard-tab': props.isProductTabVariant,
        }}
      >
        <div>
          <section class="additional-conditions-banner-content">
            <span
              class="additional-conditions-banner-content__icon"
              innerHTML={circularIcon}
            />
            <section>
              {!props.isProductTabVariant && (
                <div class="additional-conditions-banner-content-header">
                  <strong class="additional-conditions-banner-content-header__title">
                    {props.labelProvider(
                      'additional-conditions.banner.title',
                      'Sustainable product conditions available',
                    )}
                  </strong>
                </div>
              )}
              <div class="additional-conditions-banner-content__subtitle">
                <ConversationalSearchLabelWithSection text={text}/>
              </div>
            </section>
          </section>
          <section class="additional-conditions-banner__button-section">
            <qds-button
              class="additional-conditions-banner__button"
              size="large"
              importance="emphasized"
              onClick={() => props.bannerInteractionHandler()}
              text={props.labelProvider(
                'additional.conditions.banner.cta',
                'Show products',
              )}
            ></qds-button>
          </section>
        </div>
      </div>
    );
};